<div>
    <div class="row" *ngIf="unknownAccountId">
        <div class="col">
            <i class="fas fa-exclamation-triangle"></i> Unknown user
        </div>
    </div>
    <div class="row" *ngIf="!unknownAccountId">
        <div class="col">
            <div class="background-hover" [formGroup]="accountFormGroup">
                <h3>Account</h3>
                <div class="row">
                    <div class="col-3">
                        <div class="mb-3">
                            <label for="accountIdInput">Account ID</label>
                            <input type="text" class="form-control" id="accountIdInput" value="{{ account?.accountId }}" readonly>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="mb-3">
                            <label for="accountCreationTimeInput">Creation Time</label>
                            <input type="text" class="form-control" id="accountCreationTimeInput" value="{{ account?.creationTime | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}" readonly>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="mb-3">
                            <label for="accountLastAccessTokenTimeInput">Last Access Token Time</label>
                            <input type="text" class="form-control" id="accountLastAccessTokenTimeInput" value="{{ account?.lastAccessTokenTime | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}" readonly>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="mb-3">
                            <label for="accountLastRefreshTokenTimeInput">Last Refresh Token Time</label>
                            <input type="text" class="form-control" id="accountLastRefreshTokenTimeInput" value="{{ account?.lastRefreshTokenTime | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}" readonly>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <div class="mb-3">
                            <label for="accountEmailInput">Email</label>
                            <div class="float-end" *ngIf="confirmed == null">
                                <div>
                                    <span class="text-muted">
                                        <i class="fas fa-hourglass-half"></i> Checking...
                                    </span>
                                </div>
                            </div>
                            <div class="float-end" *ngIf="confirmed != null" (mouseenter)="hoverEmailStatus = true" (mouseleave)="hoverEmailStatus = false">
                                <div [hidden]="hoverEmailStatus">
                                    <span class="text-success" *ngIf="confirmed">
                                        <i class="fas fa-check-circle"></i> Confirmed
                                    </span>
                                    <span class="text-danger" *ngIf="!confirmed">
                                        <i class="fas fa-exclamation-circle"></i> Not Confirmed
                                    </span>
                                </div>
                                <div [hidden]="!hoverEmailStatus">
                                    <span class="text-muted" style="cursor: pointer;" (click)="hoverEmailStatus = false; updateEmailConfirmed();">
                                        <i class="fas fa-sync-alt"></i> Refresh
                                    </span>
                                </div>
                            </div>
                            <input type="email" class="form-control" id="accountEmailInput" formControlName="accountEmailInput" placeholder="Email...">
                        </div>
                    </div>
                    <div class="col-3" *ngIf="account?.facebook">
                        <div class="mb-3">
                            <label for="facebookIdInput">Facebook ID</label>
                            <input type="text" class="form-control" id="facebookIdInput" value="{{ account?.facebook }}" readonly>
                        </div>
                    </div>
                    <div class="col-3" *ngIf="account?.google">
                        <div class="mb-3">
                            <label for="googleIdInput">Google ID</label>
                            <input type="text" class="form-control" id="googleIdInput" value="{{ account?.google }}" readonly>
                        </div>
                    </div>
                    <div class="col-3" *ngIf="account?.twitter">
                        <div class="mb-3">
                            <label for="twitterIdInput">Twitter ID</label>
                            <input type="text" class="form-control" id="twitterIdInput" value="{{ account?.twitter }}" readonly>
                        </div>
                    </div>
                    <div class="col-3" *ngIf="account?.apple">
                        <div class="mb-3">
                            <label for="appleIdInput">Apple ID</label>
                            <input type="text" class="form-control" id="appleIdInput" value="{{ account?.apple }}" readonly>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <div class="row gx-1">
                        <div class="col-auto">
                            <button class="btn btn-sm btn-primary" [disabled]="accountFormGroup.invalid" (click)="saveAccount()">
                                <i class="fas fa-save"></i> Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="background-hover">
                <h3>Authorities</h3>
                <div [formGroup]="accountAuthorityFormGroup">
                    <div class="mb-3">
                        <div class="row gx-1">
                            <div class="col-auto">
                                <button class="btn btn-sm btn-primary" [disabled]="accountAuthorityFormGroup.invalid" (click)="saveAccountAuthorities()">
                                    <i class="fas fa-save"></i> Save
                                </button>
                            </div>
                            <div class="col-auto">
                                <button class="btn btn-sm btn-outline-primary" [disabled]="accountAuthorityFormArray.controls.length >= 7" (click)="addAccountAuthority()">
                                    <i class="fas fa-plus-circle"></i> Add
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <div>
                                <input type="text" class="form-control" id="accountRoleInput" value="{{ account?.role }}" readonly>
                                <small class="text-muted">(Role inherited from v1)</small>
                            </div>
                        </div>
                        <div class="col-3" formArrayName="accountAuthorityFormArray" *ngFor="let accountAuthorityControlGroup of accountAuthorityFormArray.controls; let i = index;">
                            <div [formGroupName]="i">
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="(ROLE_USER, ROLE_ADMIN, ...)" formControlName="accountAuthorityInput">
                                    <button class="btn btn-sm btn-outline-danger" (click)="removeAuthority(i)">
                                        <i class="fas fa-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="background-hover" [formGroup]="profileFormGroup">
                <h3>Profile</h3>
                <div class="row">
                    <div class="col">
                        <div class="mb-3">
                            <label for="profileFirstNameInput">Firstname</label>
                            <input type="text" class="form-control" id="profileFirstNameInput" formControlName="profileFirstNameInput" placeholder="Firstname...">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3">
                            <label for="profileLastNameInput">Lastname</label>
                            <input type="text" class="form-control" id="profileLastNameInput" formControlName="profileLastNameInput" placeholder="Lastname...">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3">
                            <label for="profileNickNameInput">Nickname</label>
                            <input type="text" class="form-control" id="profileNickNameInput" formControlName="profileNickNameInput" placeholder="Nickname...">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3">
                            <label for="profileGenderInput">Gender</label>
                            <input type="text" class="form-control" id="profileGenderInput" formControlName="profileGenderInput" placeholder="Gender (MALE, FEMALE)">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="mb-3">
                            <label for="profileHeightInput">Height</label>
                            <input type="text" class="form-control" id="profileHeightInput" formControlName="profileHeightInput" placeholder="Height...">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3">
                            <label for="profileHeightUnitInput">Height Unit</label>
                            <input type="text" class="form-control" id="profileHeightUnitInput" formControlName="profileHeightUnitInput" placeholder="Height Unit (CM, IN)">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3">
                            <label for="profileWeightInput">Weight</label>
                            <input type="text" class="form-control" id="profileWeightInput" formControlName="profileWeightInput" placeholder="Weight...">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3">
                            <label for="profileWeightUnitInput">Weight Unit</label>
                            <input type="text" class="form-control" id="profileWeightUnitInput" formControlName="profileWeightUnitInput" placeholder="Weight Unit  (KG, LB)">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="mb-3">
                            <label for="profileDateOfBirthInput">DateOfBirth</label>
                            <input type="text" class="form-control" id="profileDateOfBirthInput" formControlName="profileDateOfBirthInput" placeholder="DateOfBirth... (YYYY-MM-DD)">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3">
                            <label for="profileCountryInput">Country</label>
                            <input type="text" class="form-control" id="profileCountryInput" formControlName="profileCountryInput" placeholder="Country (FR, US, CN, ...)">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3">
                            <label for="localeInput">Locale</label>
                            <input type="text" class="form-control" id="localeInput" value="{{ profile?.locale }}" placeholder="Locale..." readonly>
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3">
                            <label for="timeZoneInput">TimeZone</label>
                            <input type="text" class="form-control" id="timeZoneInput" value="{{ profile?.timezone }}" placeholder="Timezone..." readonly>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <button class="btn btn-sm btn-primary" [disabled]="profileFormGroup.invalid" (click)="saveProfile()">
                        <i class="fas fa-save"></i> Save
                    </button>
                </div>
            </div>
            <hr>
            <div *ngIf="profile?.avatar">
                <h3>Avatar</h3>
                <div class="text-center mb-3">
                    <img src="{{ profile?.avatar }}" width="128px" height="128px" class="rounded-circle">
                </div>
            </div>
            <hr>
            <ul class="nav nav-tabs mb-3">
                <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" data-bs-target="#devices" (click)="loadDevices()">Devices</a></li>
                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" data-bs-target="#tracking" (click)="loadTrackingData()">Tracking</a></li>
                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" data-bs-target="#heartrate" (click)="loadHeartRateData()">HeartRate</a></li>
                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" data-bs-target="#bodytemp" (click)="loadBodyTempData()">BodyTemp</a></li>
                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" data-bs-target="#sleep" (click)="loadSleepData()">Sleep</a></li>
            </ul>
            <div class="tab-content" style="min-height: 400px;">
                <div id="devices" class="tab-pane active">
                    <div>
                        <p *ngIf="devices && devices.length == 0">
                            <i class="fas fa-exclamation-triangle"></i> No devices found
                        </p>
                    </div>
                    <div>
                        <table class="table table-sm table-striped table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">S/N</th>
                                    <th scope="col">Product</th>
                                    <th scope="col">MAC</th>
                                    <th scope="col">Firmware</th>
                                    <th scope="col">Paired</th>
                                    <th scope="col">Pairing</th>
                                    <th scope="col">Unpairing</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let device of devices">
                                    <td scope="row">
                                        <span class="">
                                            <a [routerLink]="['/devices', device.serialNumber]">
                                                <code>#{{ device.serialNumber }}</code>
                                            </a>
                                        </span>
                                    </td>
                                    <td scope="row">
                                        <span class="">{{ device.product }}</span>
                                    </td>
                                    <td scope="row">
                                        <span class="">{{ device.macAddress }}</span>
                                    </td>
                                    <td scope="row">
                                        <div *ngIf="!device.firmwares">
                                            <div class="spinner-border spinner-border-sm text-secondary" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                        <span class="" *ngFor="let f of device.firmwares">{{ f.item }}={{ f.version }}<br></span>
                                    </td>
                                    <td scope="row">
                                        <span class="">{{ !device.deleted }}</span>
                                    </td>
                                    <td scope="row">
                                        <span class="text-muted">first: {{ device.insertDatetime | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}</span><br>
                                        <span class="text-muted">last: {{ device.updateDatetime | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}</span><br>
                                    </td>
                                    <td scope="row">
                                        <span class="text-muted" *ngIf="device.deleteDatetime">last: {{ device.deleteDatetime | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div id="tracking" class="tab-pane">
                    <div [hidden]="!trackingSteps">
                        <div style="position: relative; height: 200px;">
                            <canvas id="trackingSteps" (click)="trackingStepsClick($event)"></canvas>
                        </div>
                    </div>
                    <div [hidden]="!trackingDistance">
                        <div style="position: relative; height: 200px;">
                            <canvas id="trackingDistance" (click)="trackingDistanceClick($event)"></canvas>
                        </div>
                    </div>
                    <div [hidden]="!trackingCalories">
                        <div style="position: relative; height: 200px;">
                            <canvas id="trackingCalories" (click)="trackingCaloriesClick($event)"></canvas>
                        </div>
                    </div>
                    <div [hidden]="!trackingDuration">
                        <div style="position: relative; height: 200px;">
                            <canvas id="trackingDuration" (click)="trackingDurationClick($event)"></canvas>
                        </div>
                    </div>
                    <hr>
                    <div [hidden]="!trackingStepsWeek">
                        <div style="position: relative; height: 200px;">
                            <canvas id="trackingStepsWeek" (click)="trackingStepsWeekClick($event)"></canvas>
                        </div>
                    </div>
                    <div [hidden]="!trackingDistanceWeek">
                        <div style="position: relative; height: 200px;">
                            <canvas id="trackingDistanceWeek" (click)="trackingDistanceWeekClick($event)"></canvas>
                        </div>
                    </div>
                    <div [hidden]="!trackingCaloriesWeek">
                        <div style="position: relative; height: 200px;">
                            <canvas id="trackingCaloriesWeek" (click)="trackingCaloriesWeekClick($event)"></canvas>
                        </div>
                    </div>
                    <div [hidden]="!trackingDurationWeek">
                        <div style="position: relative; height: 200px;">
                            <canvas id="trackingDurationWeek" (click)="trackingDurationWeekClick($event)"></canvas>
                        </div>
                    </div>
                </div>
                <div id="heartrate" class="tab-pane">
                    <div [hidden]="!heartRateYearChart">
                        <div style="position: relative; height: 200px;">
                            <canvas id="heartRateYearChart" (click)="heartRateYearChartClick($event)"></canvas>
                        </div>
                    </div>
                    <hr>
                    <div [hidden]="!heartRateWeekChart">
                        <div style="position: relative; height: 200px;">
                            <canvas id="heartRateWeekChart" (click)="heartRateWeekChartClick($event)"></canvas>
                        </div>
                    </div>
                </div>
                <div id="bodytemp" class="tab-pane">
                    <div [hidden]="!bodyTempYearChart">
                        <div style="position: relative; height: 200px;">
                            <canvas id="bodyTempYearChart" (click)="bodyTempYearChartClick($event)"></canvas>
                        </div>
                    </div>
                    <hr>
                    <div [hidden]="!bodyTempWeekChart">
                        <div style="position: relative; height: 200px;">
                            <canvas id="bodyTempWeekChart" (click)="bodyTempWeekChartClick($event)"></canvas>
                        </div>
                    </div>
                </div>
                <div id="sleep" class="tab-pane">
                    <div [hidden]="!sleepChart">
                        <div style="position: relative; height: 200px;">
                            <canvas id="sleepChart" (click)="sleepYearChartClick($event)"></canvas>
                        </div>
                    </div>
                    <hr>
                    <div [hidden]="!sleepWeekChart">
                        <div style="position: relative; height: 200px;">
                            <canvas id="sleepWeekChart" (click)="sleepWeekChartClick($event)"></canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>